import React, { ChangeEventHandler } from 'react';
import _ from 'lodash';
import i18n from '../../../i18n';
import BaseInput from '../../../component/form/base-input.component';
import './scss/dynamic-auto-complete-loader.scss';

class GoogleMapComponent extends React.Component<Props> {
    // 地图上inputs
    searchBox: google.maps.places.SearchBox | undefined;
    // input框
    searchInput: HTMLInputElement | null = null;
    autocompleteService: google.maps.places.AutocompleteService | null = null;
    geocoderService: google.maps.Geocoder | null = null;

    public state: State = {
        // 用户谷歌地图选中的详细地址
        formatted_address: '',
        componentError: false,
        places: [],
        changeGoogle: false,
        showPlaces: false
    }

    // ************
    // 生命周期
    // ************
    componentDidMount(): void {
        this.initializeServices();
    }

    componentDidUpdate(previousProps: Readonly<Props>): void {
        if (!previousProps.googleMapsLoaded && this.props.googleMapsLoaded) {
            this.initializeServices();
        }
    }

    /**
     * 初始化 Google Maps 地址预测与地理编码服务。
     */
    initializeServices = (): void => {
        const services = initializeGoogleMapServices(window.google);
        this.autocompleteService = services.autocompleteService;
        this.geocoderService = services.geocoderService;
    };
    UNSAFE_componentWillMount() {
        if (window.google === undefined) {
            this.setState({ componentError: true })
        }
    }

    /**
     * 地址解析
     */
    getAddress = (result: any, value: string) => {
        // 输入框的值
        const componentForm: any = {
            route: '',
            locality: '',
            administrative_area_level_1: '',
            administrative_area_level_2: '',
            country: '',
            postal_code: '',
            //  UK and in Sweden, city
            postal_town: '',
            // Brooklyn and other parts of New York City
            sublocality_level_1: ''
        };
        const lat = _.get(result, '[0].geometry.location.lat', '');
        const lng = _.get(result, '[0].geometry.location.lng', '');

        const address = {
            // 门牌号
            street_number: '',
            // 街道
            route: '',
            // 城市
            locality: '',
            // state
            administrative_area_level_1: '',
            administrative_area_level_2: '',
            // 国家
            country: '',
            // 邮编
            postal_code: '',
            // 谷歌地图place.js中的id
            google_map_place_id: _.get(result, '[0].place_id'),
            // 可读地址
            google_map_formatted_address: value || _.get(result, '[0].formatted_address'),
            // 经度
            google_map_lat: typeof lat === 'function' ? lat() : lat,
            // 纬度
            google_map_lng: typeof lng === 'function' ? lng() : lng
        };
        let address_components: any[] = [];

        if (_.isArray(result)) {
            result.forEach((item) => {
                address_components = _.concat(address_components, item.address_components)
            })
        }
        let isSpecialCountry = false;
        for (const item of address_components) {
            const addressType = item.types[0];
            if (_.has(componentForm, `${addressType}`)) {
                // $ 处理中国特别行政区
                const shortName = item.short_name
                const specialCountry = ['HK', 'MO', 'TW'];
                if (_.includes(specialCountry, shortName)) {
                    if (addressType === 'country') {
                        _.set(address, 'country', 'CN')
                        _.set(address, 'administrative_area_level_1', shortName)
                    }
                    isSpecialCountry = true
                }
                if (isSpecialCountry) {
                    if (addressType === 'administrative_area_level_1') {
                        _.set(address, 'locality', shortName)
                    } else {
                        if (!_.get(address, `${addressType}`)) {
                            _.set(address, `${addressType}`, shortName)
                        }
                    }
                } else {
                    if (!_.get(address, `${addressType}`)) {
                        _.set(address, `${addressType}`, shortName)
                    }
                }

                // 处理特殊城市字段
                if (!_.get(address, 'locality')) {
                    if (addressType === 'postal_town') {
                        _.set(address, 'locality', shortName)
                    }
                    else if (addressType === 'sublocality_level_1') {
                        _.set(address, 'locality', shortName)
                    }

                }
            }
        }

        this.props.setIsGoogleAdress?.(true);
        this.setState({ formatted_address: _.get(address, 'google_map_formatted_address', '') });
        /** 选中地址后的展示文案由外层 `onSave` 统一写入，避免与 `onChange` 双次 setState 竞态导致输入框不刷新 */
        return address;

    }


    /**
     * 搜索附近地址
     * @param value
     */
    async handleSearch(value: string) {
        try {
            if (!this.autocompleteService) {
                this.initializeServices();
            }
            this.setState({ changeGoogle: true });
            if (value) {
                this.autocompleteService?.getPlacePredictions({ input: value, language: this.props.languageCode }, (predictions) => {
                    this.setState({ places: predictions });
                })
            } else {
                this.setState({ places: [] });
            }

        } catch (error) {

        }
    }


    // 搜索地址防抖
    debounceHandleSearch = _.debounce((value: string) => {
        this.handleSearch(value);
    }, 1000);

    onPlaceChanged(place_id: string, description: string) {
        this.geocoderService?.geocode({ placeId: place_id, language: this.props.languageCode }, (results) => {
            if (!results || results.length === 0) {
                return;
            }
            const location = results?.[0]?.geometry?.location;
            if (!location) {
                return;
            }
            const { lat, lng } = location;
            const formatted_address = results?.[0]?.formatted_address;
            this.geocoderService?.geocode({ location: { lat: lat(), lng: lng(), }, language: this.props.languageCode }, (results2) => {
                const address = this.getAddress(results2, formatted_address || '');
                const resolvedText =
                    (address.google_map_formatted_address && String(address.google_map_formatted_address).trim()) ||
                    (formatted_address && String(formatted_address).trim()) ||
                    (description && String(description).trim()) ||
                    '';
                if (typeof this.props.onSave === 'function') {
                    this.props.onSave({
                        lat: address.google_map_lat,
                        lng: address.google_map_lng,
                        value: resolvedText,
                        place_id,
                        postalCode: address.postal_code,
                        country: address.country,
                        city: address.locality,
                        // 意大利使用省不是大区
                        state: address.country === 'IT' ? address.administrative_area_level_2 : address.administrative_area_level_1,
                    });
                }
                this.setState({ places: [] });
                this.props.setIsGoogleAdress?.(true);
            });
        });

    }
    render() {
        const { defaultValue, onChange } = this.props;
        const { places, showPlaces } = this.state;
        const hideFieldLabel = Boolean(this.props.hiddenLabel);
        return (
            <div className='dynamic-auto-complete-loader' id='google-map-search'>
                <BaseInput
                    ref={(ref) => this.searchInput = ref as HTMLInputElement}
                    onChange={(e) => {
                        onChange?.(e);
                        this.debounceHandleSearch(e.target.value);
                    }}
                    placeholder={this.props.placeholder || ''}
                    className={'SearchBoxinput'}
                    value={defaultValue}
                    onBlur={() => {
                        setTimeout(() => {
                            this.setState({ showPlaces: false })
                        }, 200);
                    }}
                    onFocus={() => {
                        if (!this.autocompleteService) {
                            this.initializeServices();
                        }
                        this.setState({ showPlaces: true });
                    }}
                    size='small'
                    fullWidth
                    label={hideFieldLabel ? undefined : i18n.t('restaurant_info_page_text_restaurant_address')}
                    hiddenLabel={hideFieldLabel}
                />
                {showPlaces && places?.length ? <div className='pac-container'>
                    {places.map((item, index) => {
                        return (
                            <div
                                key={`${index}`}
                                className='pac-item'
                                onMouseDown={(e) => {
                                    /** 防止点击建议时输入框先 blur，导致 click 丢失或状态不同步 */
                                    e.preventDefault();
                                }}
                                onClick={() => {
                                    this.onPlaceChanged(item.place_id, item.description);
                                }}
                            >
                                <span className='pac-icon pac-icon-marker' />
                                <span>{item.description}</span>
                            </div>
                        );
                    })}
                </div> : null}
            </div>
        )
    }
}
export default GoogleMapComponent
// *********************
// Types
// *********************
type Props = {
    className?: string;
    placeholder?: string;
    onSave?: (val: GooglePlace) => void;
    setIsGoogleAdress?: (val: boolean) => void;
    // 初始值
    defaultValue: string;
    onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
    // 语言
    languageCode?: string;
    /** Google Maps 脚本是否已经加载完成。 */
    googleMapsLoaded?: boolean;
    /** 为 true 时不显示输入框浮动标签（由外层如 `FormFieldCell` 提供标题） */
    hiddenLabel?: boolean;
}
type State = {
    formatted_address: string | undefined;
    componentError: boolean;
    places: google.maps.places.AutocompletePrediction[];
    changeGoogle: boolean;
    showPlaces: boolean;
};


// 谷歌地址类型
export type GooglePlace = {
    // 纬度
    lat?: number;
    // 经度
    lng?: number;
    // 地址
    value?: string;
    /** Google Place ID（写评论链接等） */
    place_id?: string;
    // 邮编
    postalCode?: string;
    // 国家
    country?: string;
    // 城市
    city?: string;
    // 省份
    state?: string;
}

/**
 * 初始化 Google Maps 地址搜索依赖。
 * @param googleMaps 已加载的 Google Maps 全局对象
 * @returns 地址预测服务和地理编码服务
 */
export function initializeGoogleMapServices(googleMaps?: typeof window.google): {
    autocompleteService: google.maps.places.AutocompleteService | null;
    geocoderService: google.maps.Geocoder | null;
} {
    if (!googleMaps?.maps?.places) {
        return {
            autocompleteService: null,
            geocoderService: null,
        };
    }

    return {
        autocompleteService: new googleMaps.maps.places.AutocompleteService(),
        geocoderService: new googleMaps.maps.Geocoder(),
    };
}